module.exports = __webpack_public_path__ + "static/media/logo-text.3b9e218f.svg";